import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// let baseUrl = `http://localhost:6379/`;
let baseUrl = `/`;
// let baseUrl = `https://movie.uvcann.com/`;
// let baseUrl=`https://www.movieflix.visiontrek.in/`;

const baseQuery = fetchBaseQuery({ baseUrl: baseUrl });

export const apiSlice = createApi({
  baseQuery: baseQuery,
  tagTypes: ["Trending", "Discover", "GenreList", "Movie", "Series", "User","Reviews","Search","Community","Shortz","Watchlist"],
  endpoints: (builder) => ({}),
});

export { baseUrl };